<template>
  <div>
    <div class="mainbgTwo"><img src="../assets/images/news/mainbgTwo.jpg" alt=""></div>
    <div class="container">
        <div class="row rowwarp">
            <div class="rowwpRight">
                <div class="itemtop">
                    <img src="../assets/images/news/brnav_home.png" alt="">
                    <span><a href="javascript:void(0);" @click="returnBack">   首页</a></span>
                    <span>&gt;</span>
                    <span><a href="javascript:void(0);">友情链接</a></span>
                </div>
                <div class="box" v-loading="loading">
                    <ul class="gallery-container gallery-fancybox masonry-gallery">
                      <li v-for="(items , index) in linksGroup" :key="index">
                        <div class="newShow">
                          <div class="newShowTitle">{{items.Name}}</div>
                          <div class="row rowShow">
                            <p class="showContent" v-for="(childitems,childIndex) in items.children" :key="childIndex">
                              <a :href="childitems.Url" target="_blank">{{childitems.Name}}</a>
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as utils from '../utils.js'
import * as api from '../api/api.js'
export default {
  data () {
    return {
      htmlCont: '',
      loading: false,
      linksGroup: []
    }
  },
  created () {
    this.getLinks ()
  },
  methods: {
    // 返回首页
    returnBack(){
      this.$router.push({path: '/'})
    },
    getLinks(){
      api.LinkGroupModules().then(res =>{
        if(res.Status === 100){
          var Params = {
            Page: 1,
            PageSize: 200
          }
          api.LinkRefModules(Params).then(resTwo =>{
            if(resTwo.Status === 100){
              res.Data.DataList.forEach((vv)=>{
                vv.children =[]
                resTwo.Data.DataList.find((dd)=>{
                  if(dd.Ass_LinkGroup_Id === vv.Id){
                    vv.children.push(dd)
                  }
                })
              })
              this.linksGroup = res.Data.DataList
              utils.storage.set('linksList',res.Data.DataList)
            }else {
              this.$message({message: '获取友情链接异常' ,type: 'warning'})
            }
          })

        }else {
          this.$message({message: '获取友情链接分组异常',type: 'warning'})
        }
      })
    }
  }
}
</script>
<style>
  .attachment img {
    height: 30px;
    width: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/link.vue